<script>
  import { createEventDispatcher } from 'svelte';
  import { Button, Pagination, PaginationItem } from "sveltestrap";

  export let total = 0;     // total de items
  export let xpage = 10;    // items por página
  export let current = 1;   // página actual
  export let onPageClick; 
  const dispatch = createEventDispatcher();

  let pages = [];

  // Recalcula páginas cuando cambian total, xpage o current
  $: if (total > 0 && xpage > 0 && current > 0) {
    generatePageRange();
  } else {
    pages = [];
  }

  function generatePageRange() {
    const visiblePages = 5;
    const totalPages = Math.ceil(total / xpage);
    const middlePage = Math.ceil(visiblePages / 2);

    let startPage = Math.max(1, current - middlePage + 1);
    let endPage = Math.min(totalPages, current + middlePage - 1);

    // Ajustar rango para siempre mostrar visiblePages si es posible
    const visibleCount = endPage - startPage + 1;
    if (visibleCount < visiblePages) {
      if (startPage === 1) {
        endPage = Math.min(totalPages, endPage + (visiblePages - visibleCount));
      } else if (endPage === totalPages) {
        startPage = Math.max(1, startPage - (visiblePages - visibleCount));
      }
    }

    const range = [];
    for (let i = startPage; i <= endPage; i++) {
      range.push(i);
    }
    pages = range;
  }

  function changePage(page) {

    const totalPages = Math.ceil(total / xpage);
    if (page < 1 || page > totalPages || page === current) return;
    current = page;
    onPageClick(current)

  }
</script>

<nav class="pagination">
  <span class="total-info">Total {total} items.</span>

  <Pagination>
    <PaginationItem disabled={current === 1}>
      <Button class="page-link" on:click={() => changePage(current - 1)}>
        <span aria-hidden="true">&laquo;</span>
      </Button>
    </PaginationItem>

    {#each pages as page}
      <PaginationItem active={current === page}>
        <Button class="page-link" on:click={() => changePage(page)}>
          {page}
        </Button>
      </PaginationItem>
    {/each}

    <PaginationItem disabled={current === Math.ceil(total / xpage)}>
      <Button class="page-link" on:click={() => changePage(current + 1)}>
        <span aria-hidden="true">&raquo;</span>
      </Button>
    </PaginationItem>
  </Pagination>
</nav>



<style>
  .pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 1em 0; /* Add some margin for better visual separation */
  }

  .total-info {
    color: black;
    margin-right: 1em; /* Separate the total information from the pagination buttons */
  }
  @media (max-width: 768px) {
    .pagination {
      /* Adjust pagination layout for smaller screens (optional) */
      flex-wrap: wrap;
    }
  }
</style>
